export const environment = {
  production: true,
  HOST: "https://bluehill.hu",
  API_PATH_PREFIX: "/api/v1/",
  API_RETRY: 2,
  BRANDING_LOGO: "storage/bluehill_logo_white.png",
  SENTRY_DSN: "https://a97c45706aa24137b6a341f0a21b0939@o251613.ingest.sentry.io/4504085806645248",
  SCANNER_READ_LOCK_SECONDS: 2500,
  AUTO_SYNC_INTERVAL: 300000
};
